import { QuestionBase } from './question-base';
export class DocumentsUploader extends QuestionBase<Object> {
  controlType = 'documentsUploader';
  info: string;
  maxSizeInMB: number;
  constructor(options: {} = {}) {
    super({ ...options, designSystem: false });
    this.maxSizeInMB = options['maxSizeInMB'] || 5;
  }
}
